import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const ShopBox = ({
  id,
  deleteItem,
  length,
  quantities,
  setQuantities,
  cartItems,
  setCartItems,
}) => {
  const [socks, setSocks] = useState([]);
  const [isEmpty, setIsEmpy] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios.get('https://cottonlocalhost1365.onrender.com/api/Items/')
      .then(response => {
        setSocks(response.data);
        setLoading(false); 
      })
      .catch(error => {
        console.error('There was an error fetching the data!', error);
        setLoading(false); 
      });
  }, []);

  useEffect(() => {
    handleIsEmpy();
  }, [cartItems]);

  const handleIsEmpy = async () => {
    if (cartItems.length) {
      setIsEmpy(false);
    } else {
      setIsEmpy(true);
    }
  };

  // Calculate the current quantity of each item in the cart
  const filteredProducts = socks
    .filter((sock) => cartItems.some((item) => item.productId === sock._id))
    .map((sock) => ({
    ...sock,
    quantity: cartItems.find((item) => item.productId === sock._id)?.quantity || 1, // Use cartItems for quantity
  }));

  const totalPrice = filteredProducts.reduce((total, sock) => {
    return total + sock.price * sock.quantity;
  }, 0);

  const productsQuery = encodeURIComponent(JSON.stringify(filteredProducts));
  const priceQuery = encodeURIComponent(totalPrice);

  return (
    <div className="mt-28 md:mt-0 flex items-center justify-center min-h-screen opacity-0 animate-fade-in"
      style={{ animationDelay: `${3 * 0.1}s` }}>
      {loading ? (
        // Loading spinner and message
        <div className="flex flex-col items-center justify-center min-h-screen">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
          <p className="mt-4 text-[#333333] text-lg">Loading perfect socks...</p>
        </div>
      ) : (
      <div className="grid lg:grid-cols-2 grid-cols-1">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((sock) => (
            <div key={sock._id}>
              <div className="flex flex-row items-center text-[#2C3E50]">
                <img src={sock.name} alt="Kotton Socks" className="md:w-[250px] md:h-[290px] w-[150px] h-[155px] rounded-xl m-3" />
                <div className="flex flex-col items-center lg:mx-7">
                  <h3 className="text-sm md:text-2xl">{sock.description}</h3>
                  <h4 className='text-xs md:text-xl text-indigo-400'>Price: {sock.price} €</h4>
                  <h4 className='text-xs md:text-xl text-[#1A2A3A] bg-white rounded-xl p-1 pl-2 pr-2 m-2'>Quantity: {sock.quantity}</h4>
                  <button
                    onClick={() => deleteItem(sock._id)} // Call deleteItem with the item ID
                    className="bg-red-500 h-8 rounded-xl w-32"
                  >
                    Delete Item
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className='text-white font-serif bg-indigo-600 rounded-xl w-[200px] h-[25px] animate-bounce'>
            Your Cart Is Empty
          </div>
        )}
        {!isEmpty && (
          <div className="flex flex-col justify-center items-center">
            <div className="text-[#2C3E50] text-2xl font-bold mt-4 mb-4">
              Total Price: {totalPrice.toFixed(1)} €
            </div>
            <Link to={`/submit-order?products=${productsQuery}&price=${priceQuery}`}>
              <button className='transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300 text-white rounded-2xl w-40 bg-indigo-700 my-7 animate-bounce'>
                Order Now
              </button>
            </Link>
          </div>
        )}
      </div>
      )}
    </div>
  );
};

export default ShopBox;